// i18n dictionary — English (default) & Marathi.
// Keep keys stable; add new sections here rather than sprinkling literals across files.
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./en.json";
import mr from "./mr.json";

export const SUPPORTED_LANGUAGES = [
  { code: "en", label: "English",  native: "English" },
  { code: "mr", label: "Marathi",  native: "मराठी"   },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      mr: { translation: mr },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "mr"],
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "welworth.lang",
    },
    interpolation: { escapeValue: false },
    returnEmptyString: false,
  });

export default i18n;
